import { Component, Input } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../../providers/tools/tools';
// import { ToolsProvider } from '../../../../providers/tools/tools';

@Component({
  selector: 'job-card',
  templateUrl: 'job-card.html',
})
export class JobCardComponent {
  log = debug('app:JobCardComponent');

  @Input() job: any;

  constructor(public tools: ToolsProvider) {}

  logoUrl: string;
  headline: string;
  companyName: string;
  details: string;
  tagline: string;

  ngOnInit() {
    this.log('job ad card', this.job);

    this.headline =
      _.get(this.job, 'jobInformation.job.descriptionCardTitle') ||
      _.get(this.job, 'jobInformation.job.title');

    // records.forEach(job => {
    //   job.jobInformation.job.trailerType = this.addSlash(
    //     job.jobInformation.job.trailerType
    //   );
    //   job.jobInformation.job.driverType = this.soloSpace(
    //     job.jobInformation.job.driverType
    //   );
    //   job.jobInformation.job.type = this.capitalizeFirst(
    //     job.jobInformation.job.type
    //   );
    //   job.jobInformation.job.curatedContent = this.addEllipses(
    //     job.jobInformation.job.curatedContent,
    //     187
    //   );
    //   job.jobInformation.job.descriptionCardTitle = this.addEllipses(
    //     job.jobInformation.job.descriptionCardTitle,
    //     60
    //   );
    //   job.jobInformation.job.title = this.addEllipses(
    //     job.jobInformation.job.title,
    //     60
    //   );
    // });
  }

  addEllipses(str, limit) {
    if (str.length > limit) {
      return str.substring(0, limit) + '...';
    }
    return str;
  }

  addSlash(arr) {
    let newArr = [];
    for (let i = 0; i < arr.length; i++) {
      if (i !== arr.length - 1) {
        arr[i] = this.capitalizeFirst(arr[i]);
        newArr.push(arr[i] + '/');
      } else {
        arr[i] = this.capitalizeFirst(arr[i]);
        newArr.push(arr[i]);
      }
    }
    return newArr;
  }

  capitalizeFirst(str) {
    if (str === 'otr' || str === 'otr-freeform') {
      let newStr = str.replace('otr', 'OTR');
      return newStr;
    } else {
      let newStr = str[0].toUpperCase() + str.substring(1);
      return newStr;
    }
  }

  soloSpace(str) {
    let newStr = str.replace('solo', 'Solo ');
    return newStr;
  }

  navToJobApp(post) {
    let jobId = _.get(post.jobInformation.job, '_id');

    this.tools.logAnalyticsEvent(
      'trackCustom',
      'nav-to-job-posting-from-explore-page',
      post
    );

    this.tools.openExternalUrl(
      `https://landing.cdllife.com/job/${jobId}`,
      '_blank',
      {
        rt: 'mobileApp',
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/job-card/job-card.ts